<template>

  <div>
        <div class="breadcrumb-list">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Leaves</a></li>
          </ol>
        </div>
        <div class="main-box two-column message-page">
          <aside class="right-side right-side-reverse">
            <div class="catagories">
              <div class="catagory-head">
                <h5>Positions</h5>
              </div>
              <ul class="check-list">
                <li v-for="(role,index) of logInUser.jobRoles" :key="index" v-show="logInUser.managerAccess=='yes' && logInUser.is_leave_access==1">
                  <div class="sticky-check">
                    <label class="custom-check-box">
                      <input type="checkbox" v-model="searchByRole" :value="role.get_job_roles.id" @change="filterLeaves" name="check01" />
                      <span class="radio-check text-capitalize">{{ role.get_job_roles.name }} </span>
                    </label>
                  </div>
                </li>
                <li v-for="(role) of jobRoles" :key="role.id" v-show="logInUser.managerAccess!=='yes' && logInUser.is_leave_access==0">
                  <div class="sticky-check">
                    <label class="custom-check-box">
                      <input type="checkbox" v-model="searchByRole" :value="role.id" @change="filterLeaves" name="check01" />
                      <span class="radio-check text-capitalize">{{ role.name }} </span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="catagories">
              <div class="catagory-head">
                <h5>Type</h5>
              </div>
              <ul class="check-list">
                <li v-for="(lvName,index) of leavesNames" :key="index">
                  <div class="sticky-check">
                    <label class="custom-check-box">
                      <input type="checkbox" v-model="searchByLeaveType" :value="lvName" @change="filterLeaves" name="check01" />
                      <span class="radio-check text-capitalize"> {{ lvName }} </span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="catagories">
              <div class="catagory-head">
                <h5>Employees</h5>
              </div>
              <ul class="check-list">
                <li v-for="(empl,index) of filteredEmployees" :key="index">
                  <div class="sticky-check">
                    <label class="custom-check-box">
                      <input type="checkbox" v-model="searchByEmployee" :value="empl.id" @change="filterLeaves" name="check01" />
                      <span class="radio-check">
                        <div class="image-check">
                            <img
                              :src="$API_URL+'storage/'+empl.image"
                              alt="Profile image"
                              width="80"
                              height="80"
                              v-if="empl.image !== ''"
                            />
                          <strong v-else-if="empl.image === ''" class="profile-name text-uppercase">
                            {{ getNameFirstLetter2(empl.name) }}
                          </strong>
                        </div>
                        <div class="text-capitalize">
                         {{ empl.name }}
                        </div>
                      </span>
                    </label>
                  </div>
                </li>
              </ul>
              <div v-show="filteredEmployees.length >= 15">
                <a href="javascript:void(0);" class="btn btn-outline-primary" @click="loadMoreEmployee">Load more</a>
              </div>
            </div>
          </aside>

          <div class="left-side left-side-reverse bg-transparent absence-left">
            <div class="row bg-white two-calender">
              <div class="col-md-12">
            <a
              href="javascript:void(0)"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="emptyLeave"
            >
              Add leave
            </a>
            <a
              href="javascript:void(0)"
              class="btn btn-outline-primary btn-sm float-right"
              data-toggle="modal"
              data-target="#leaves-status"
              @click="uniqueKeyFunction"
            >
             {{ pendingLeaveCount }} Leaves Waiting Approval
            </a>
                <div id="c-id">
                  <calendar-view
                    :show-date="showDate"
                    class="theme-default holiday-us-traditional holiday-us-official"
                    :items="item"
                    @click-item="itemClickShowModal($event)"
                  >

                    <template #header="{ headerProps }">

                      <calendar-view-header
                        :header-props="headerProps"
                        @input="setShowDate"
                      />

                    </template>
                  </calendar-view>
                </div>
              </div>
            </div>
          </div>
        </div>

    <!-- leaves status modal -->

    <div
      class="modal fade add-absence-model"
      id="leaves-status"
      tabindex="-1"
      role="dialog"
      aria-labelledby="add-absenceLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg maxWidth990" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5>{{ showDate.toDateString() }} </h5>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="clearleave2"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body approve-model">
            <table class="table">
              <caption></caption>
              <thead>
                <tr>
                  <th scope="col">Employee</th>
                  <th scope="col">Type</th>
                  <th scope="col">Date</th>
                  <th scope="col">Days</th>
                  <th scope="col">Duration Type</th>
                  <th scope="col">Half Day Type</th>
                  <th scope="col">From - To</th>
                  <th scope="col" colspan="2">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(leave,index) of pendingLeaveEmployee" :key="index">
                  <td>
                    <h5 class="text-capitalize"> {{ leave.userOnLeave.name }} </h5>
                  </td>
                  <td>{{ leave.type }}</td>
                  <td>
                    {{ moment(leave.start_datetime,'YYYY-MM-DD HH:mm:ss').format('DD-MMM-YYYY') }} -
                    {{ moment(leave.end_datetime,'YYYY-MM-DD HH:mm:ss').format('DD-MMM-YYYY') }}
                  </td>
                  <td>{{ new Date(leave.end_datetime).getDate() - new Date(leave.start_datetime).getDate() + 1 }}</td>
                  <td class="text-capitalize">{{ formatDurationType(leave.duration_type) }}</td>
                  <td>{{ leave.is_half_day_type }}</td>
                  <td>{{ leave.from_specify_time }} - {{ leave.to_specify_time }}</td>
                  <td>
                    <a href="javascript:void(0)" class="btn btn-outline-primary" @click="approveTheLeave(leave.id,'approve')">Approve</a>
                  </td>
                  <td>
                    <a href="javascript:void(0)" class="btn btn-outline-warning" @click="approveTheLeave(leave.id,'reject')">Reject</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- add leave Modal -->

    <div
      class="modal fade add-absence-model"
      id="add-absence"
      tabindex="-1"
      role="dialog"
      aria-labelledby="add-absenceLabel"
      aria-hidden="true"
    >

      <div class="modal-dialog" role="document">

        <div class="modal-content">

          <div class="modal-header">

            <div class="modal-title">

              <h5>Add Employee Leave</h5>

              <p class="gray-text">
                Pick employee below that you want to create leave for..
              </p>

            </div>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >

              <span class="ico-cross"></span>

            </button>

          </div>

          <div class="modal-body">

            <div class="searchbar-holder">

              <label>Pick Employee</label>

              <div class="input-wrapper">

                <input type="text" class="form-control " placeholder="Search" v-model="search" @keyup="searchEmployees" />

                <i class="ico ico-Search"></i>

              </div>

            </div>

            <div class="emp-search-list">

              <ul class="emp-list-link">

                <li v-for="(employee,index) of searchEmployeeForLeave" :key="index" @click="getEmployeeid(employee)"
                  data-dismiss="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#calenModel"
                >
                  <span class="emp-img">
                    <img
                      :src="$API_URL+'storage/'+employee.image"
                      alt="Profile image"
                      width="22"
                      height="22"
                      v-if="employee.image !== ''"
                    />
                    <span v-if="employee.image === ''" class="profile-name">
                      {{ getNameFirstLetter2(employee.name) }}
                    </span>
                  </span>
                  <div class="descrip">
                    <span class="empl-name">{{ employee.name }}</span>
                    <span class="emp-designation">
                      <span v-for="role of employee.employeeJobType" :key="role.id">
                        <i data-v-20dc72fd="" class="ico ico-fill-circle" :style="{color:role.get_job_roles !== null? role.get_job_roles.color: ''}"></i>
                        {{ role.get_job_roles !== null? role.get_job_roles.name : '' }}
                      </span>
                    </span>
                  </div>
                </li>
              </ul>
              <div v-show="filteredEmployees.length >= 15 && loadMoreCheck" class="load-margin">
                <a href="javascript:void(0);" class="btn btn-outline-primary" @click="loadMoreEmployee">Load more</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <LeaveModels :shiftData="shiftData" :editLeave="editLeave" :company_leave_type_id="company_leave_type_id" :employeeLeaveBalance="employeeLeaveBalance" :leaveData="leaveData" :leaveTypeWhenUpdate="selectedLeave" :rangeUpdate="range" :leavesAllowed="leavesAllowed" :totalAllowedLeaves="totalAllowedLeaves" :key="uniqueKey" />

  </div>

</template>

<script>

import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import "../../assets/css/calandar/style.css"
import "vue-simple-calendar/static/css/default.css"
import "vue-simple-calendar/static/css/holidays-us.css"
import DatePicker from 'vue2-datepicker'
import collect from "collect.js";
import LeaveModels from './leaveModals.vue'
import Swal from "sweetalert2";
import axios from "axios";


export default {
  name: 'companyProfile',
  components: {
    CalendarView, CalendarViewHeader,DatePicker,LeaveModels
  },
  data: function() {
    return {
        searchByRole            :[],
        searchByLeaveType       :[],
        searchByEmployee        :[],
        jobRoles                :this.$store.getters.getSelectedCompany.jobRoles,
        logInUser               : this.$store.getters.getUser,
        showDate                : new Date(),
        item                    :[],
        copyItems               :[],
        filteredEmployees       :[],
        employees               :[],
        inputShowHide           :false,
        leaveType               :'',
        leaveType2              :'',
        addedRadioButton        :false,
        selectedLeave           :'Vacation',
        leaveDate               :'',
        date                    :'',
        time                    :'',
        datetime                :'',
        range                   :'',
        range2                  :'',
        leaveNote               :'',
        search                  :'',
        leaveData               :[],
        leaves                  :[],
        shiftData               :[],
        employeeShifts          :[],
        getEmployeeLeaves       :[],
        leavesNames             :[],
        searchEmployeeForLeave  :[],
        editLeave               :{},
        rangeRequired           :'',
        pendingLeaveEmployee    :[],
        pendingLeaveCount       :0,
        acceptClass             :'',
        rejectClass             :'',
        invalidType             :'',
        leaveNotAvailable       :'',
        leaveStatusText         :'',
        imgNotFnd               : false,
        uniqueKey               : 0,
        allowedLeaves           : {},
        leavesAllowed           : 0,
        totalAllowedLeaves      : 0,
        page                    : 1,
      employeeLeaveBalance                    : '--',
      company_leave_type_id                    : '',
        totalEmployees          : [],
        loadMoreCheck : true,
        userOnLeave             :this.$store.getters.getUser,
      }
    },
  methods:{
    formatDurationType(durationType) {
      if (typeof durationType === 'string') {
        return durationType.replace(/_/g, ' ');
      }
      return durationType;  // Return the value as is if it's not a string (or return a default value if needed)
    },
    uniqueKeyFunction(){

      this.uniqueKey++;
       $('#leaves-status').modal('show');
    },
    imageNotFound(event){
      if(event.type === 'error'){
        let imgTag = $(event.target);
        $(event.target).remove();
        this.imgNotFnd = true;
      }
    },
    imgLoad(event){
      this.imgNotFnd = false;
    },
    getNameFirstLetter2(name){
      return this.getNameFirstLetter(name);
    },
    approveTheLeave(id,approveType){
      let message = approveType === 'approve' ? 'Are you sure you want to approve this leave?':'Are you sure you want to reject this leave?';
      message = approveType === 'delete' ? 'Are you sure you want to delete this leave?' : message;
      new Swal({
        title: "Leave Confirmation",
        icon: "warning",
        text: message,
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes"
      }).then((result) => {
        $('#leaves-status').modal('hide');
          if (result.value) {
              this.$axios({
              method: 'POST',
              data: {id:id,approveType:approveType},
              url: this.$LeaveApproveReject,
              headers: this.getAuthHeader()
            }).then((res) => {
              if(res.data.status == 200){
                this.getAllLeaves();
                $root.$toast.success(res.data.message);
              }
            })
          }

      });

    },
    filterLeaves(){
      this.item = this.copyItems;
      if(this.searchByRole.length !== 0){
          this.item = this.item.filter(i => {
            for(let it of i.roles){
              if(this.searchByRole.includes(it))
              return i;
          }
          });
      }
      if(this.searchByLeaveType.length !== 0){
        this.item = this.item.filter(lv => {
          if(this.searchByLeaveType.includes(lv.type))
          return lv;
        });
      }
      if(this.searchByEmployee.length !== 0){
        this.item = this.item.filter(itm => {
          if(this.searchByEmployee.includes(itm.empl_id))
          return itm;
        });
      }

    },
    searchEmployees() {
      this.loadMoreCheck = false;
      this.searchEmployeeForLeave = this.filteredEmployees = this.employees;
      collect().macro("whereLike", function(search) {
        var searched = new RegExp(search, "i");
        return this.filter(item =>
          searched.test(item.name + "?" + item.phone + "?" + item.email)
        );
      });
      if(this.search!==''){
        this.searchEmployeeForLeave = collect(this.totalEmployees)
          .whereLike(this.search)
          .all();
      }else{
        this.loadMoreCheck = true;
      }
    },
    getLeaveStatusEmployee(){
      this.$axios({
        method  : "get",
        params  : {
          company_id  : this.$store.getters.getSelectedCompany.id
        },
        url     : this.$GetLeavesWaiting,
        headers : this.getAuthHeader()
      }).then((res) => {
        if(res.data.status === 200){
          this.pendingLeaveEmployee = res.data.result;
          this.pendingLeaveCount    = this.pendingLeaveEmployee.length;
          console.log('length',this.pendingLeaveCount);
        }
      });
      // this.pendingLeaveEmployee = collect(this.getEmployeeLeaves).filter(item => item.status === 'Pending').sortByDesc();
    },
    loadMoreEmployee(){
      this.page++;
      this.$axios({
        method    : "get",
        params    : {
          company_id  : this.$store.getters.getSelectedCompany.id,
          filter_by   : "EMPLOYEE",
          page        : this.page
        },
        url     : this.$GetEmployees,
        headers : this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.filteredEmployees  = [...this.filteredEmployees,...res.data.result];
          this.employees              = this.filteredEmployees;
          this.searchEmployeeForLeave = this.filteredEmployees;
        }
      });
    },
    getAllLeaves(){
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
        },
        url: this.$GetAllLeaves,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          //this.pendingLeaveCount    = 0;
          //this.pendingLeaveEmployee = [];
          this.getEmployeeLeaves    = res.data.result;
          this.allowedLeaves        = {};
          /*this.item = this.getEmployeeLeaves.map((i) => {
            if(!this.leavesNames.includes(i.type)){
              this.leavesNames.push(i.type);
            }
            let aray                  = {};
            aray['id']                = i.id;
            aray['company_leave_type_id'] = i.company_leave_type_id;
            aray['startDate']         = i.start_datetime
            aray['endDate']           = i.end_datetime
            aray['title']             = i.userOnLeave.name+"-"+i.type
            aray['employeeName']      = i.userOnLeave.name
            aray['roles']             = i.employeeRole.map(rol => rol.get_job_roles !== null ? rol.get_job_roles.id : 0)
            aray['type']              = i.type
            aray['note']              = i.body
            aray['duration_type']     = i.duration_type
            aray['is_half_day_type']  = i.is_half_day_type
            aray['from_specify_time'] = i.from_specify_time
            aray['to_specify_time']   = i.to_specify_time
            aray['empl_id']           = i.employee_id
            aray['classes']           = ['text-capitalize']
            let rolll                 = i.employeeRole.map(rol => rol.get_job_roles !== null ? rol.get_job_roles : []);
            aray['style']             = `background-color: ${rolll.length > 0 ? rolll[0].color : '#242424'} !important;color:white !important;text-align:center !important;cursor: pointer;`;
            return aray;

          });*/
          this.item = this.getEmployeeLeaves.map((i) => {
            if (!this.leavesNames.includes(i.type)) {
              this.leavesNames.push(i.type);
            }

            let aray = {};
            aray['id'] = i.id;
            aray['company_leave_type_id'] = i.company_leave_type_id;
            aray['startDate'] = i.start_datetime;
            aray['endDate'] = i.end_datetime;

            // Check if userOnLeave is not null before accessing name
            aray['title'] = (i.userOnLeave && i.userOnLeave.name) ? `${i.userOnLeave.name} - ${i.type}` : i.type;
            aray['employeeName'] = (i.userOnLeave && i.userOnLeave.name) ? i.userOnLeave.name : 'Unknown Employee';

            aray['roles'] = i.employeeRole.map(rol => rol.get_job_roles !== null ? rol.get_job_roles.id : 0);
            aray['type'] = i.type;
            aray['note'] = i.body;
            aray['duration_type'] = i.duration_type;
            aray['is_half_day_type'] = i.is_half_day_type;
            aray['from_specify_time'] = i.from_specify_time;
            aray['to_specify_time'] = i.to_specify_time;
            aray['empl_id'] = i.employee_id;
            aray['classes'] = ['text-capitalize'];

            let rolll = i.employeeRole.map(rol => rol.get_job_roles !== null ? rol.get_job_roles : []);
            aray['style'] = `background-color: ${rolll.length > 0 ? rolll[0].color : '#242424'} !important;color:white !important;text-align:center !important;cursor: pointer;`;

            return aray;
          });
          this.copyItems      = this.item;
          this.selectedLeave  = 'Vacation';
          this.uniqueKey++;
        }
        this.getLeaveStatusEmployee();
      });
    },
    getEmployeeid(employee){
      this.$root.$emit("leaveTypeUpdate", employee.id);
      this.selectedLeave              = '';
      this.leaveData['empl_Id']       = employee.id;
      this.leaveData['name']          = employee.name;
      this.selectedLeave              = 'Vacation';
      this.totalAllowedLeaves         = employee.monthly_allow_leaves;
      this.leavesAllowed              = employee.monthly_allow_leaves;
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
          user_id: employee.id,
        },
        url: this.$EmployeeShiftForLeave,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          this.shiftData = res.data.result;
          this.selectedLeave = 'Vacation';
        }
      });
    },
    emptyLeave(){
      $('#add-absence').modal('show')
      this.addedRadioButton   = false;
      this.selectedLeave      = 'Vacation';
      this.leaveNotAvailable  = '';
      this.range              = '';
      this.uniqueKey++;
    },
    addInputFiled(){
      if(this.inputShowHide == false){
        this.inputShowHide = true;
      }else{
        this.inputShowHide = false;
      }
    },
    getEmployeeLeaveBalance(company_leave_type_id,empl_id){
      axios.get(this.$EmployeeLeaveEntitlements+'/leave-balance', {
        headers: this.getAuthHeader(),
        params: {
          company_leave_type_id: company_leave_type_id,
          employee_id: empl_id,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.employeeLeaveBalance = res.data.result;
          }
        });
    },
    itemClickShowModal(event){
      this.addedRadioButton = false;
      this.inputShowHide    = false;
      this.selectedLeave    = '';
      this.company_leave_type_id=event.originalItem.company_leave_type_id;
      this.getEmployeeLeaveBalance(event.originalItem.company_leave_type_id,event.originalItem.empl_id);
      this.editLeave = {
        'company_leave_type_id': event.originalItem.company_leave_type_id,
        'name'              : event.originalItem.employeeName,
        'type'              : event.originalItem.type,
        'startDate'         : event.startDate,
        'endDate'           : event.startDate,
        'id'                : event.id,
        'emplId'            : event.originalItem.empl_id,
        'note'              : event.originalItem.note,
        'duration_type'     : event.originalItem.duration_type,
        'is_half_day_type'  : event.originalItem.is_half_day_type,
        'from_specify_time' : event.originalItem.from_specify_time,
        'to_specify_time'   : event.originalItem.to_specify_time,
      }
      this.leaveNote = event.originalItem.note;
      if(event.originalItem.type !== 'Vacation' && event.originalItem.type !== 'Sick'){
        this.addedRadioButton = true;
        this.leaveType2       = event.originalItem.type;
        this.selectedLeave    = event.originalItem.type;
      }else{
        this.selectedLeave = 'Vacation';
      }
      this.range = [new Date(event.startDate), new Date(event.endDate)];
      $('#itemShowModal').modal('show');

    },
    setShowDate(d) {
      this.showDate = d;
    },
    getAllEmployees(){
      this.$axios({
      method: "get",
      params: {
        company_id  : this.$store.getters.getSelectedCompany.id,
        filter_by   : "EMPLOYEE"
      },
      url: this.$GetEmployees,
      headers: this.getAuthHeader()
    }).then(res => {
      if (res.data.status == 200) {
        this.filteredEmployees      = res.data.result;
        this.totalEmployees         = res.data.message.totalEmployees;
        this.employees              = this.filteredEmployees;
        this.searchEmployeeForLeave = this.filteredEmployees;
      }
    });
    },
    clearleave2(){
      this.addedRadioButton = false;
      this.inputShowHide == false
      this.selectedLeave = 'Vacation';
      this.range = '';
      this.leaveNotAvailable = '';
      document.querySelector(".modal-backdrop").remove();
      $('.period-list li.selected').removeClass('selected');
      $('.first-li').addClass('selected');
      this.getAllLeaves();
  },
  },
  mounted(){
    this.getAllEmployees();
    this.getAllLeaves();
    this.getLeaveStatusEmployee();
    this.$root.$on("refreshLeaves", () => {
      this.getAllLeaves();
    });
    this.$root.$on("refreshCompo", () => {
      this.uniqueKey++;
    });
    this.range2 = [new Date(),new Date()];
  },
}
</script>

<style>
.empl-name{
  cursor: pointer;
}
.accept{
    color: #00779C !important;
    border:1px solid #00779C !important;
    background-color: #fff !important;
    text-align: center !important;
    cursor: pointer;
}
.reject{
    color: #CB6F11 !important;
    border:1px solid #CB6F11 !important;
    background-color: #fff !important;
    text-align: center !important;
    cursor: pointer;
}
/* .mx-range-wrapper {
    height: 0px !important;
} */
#c-id {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  color: #2c3e50;
  height: 750px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.emp-img:hover{
  cursor: pointer;
}
/* .cv-item{
  cursor: pointer;
} */
.textRed{
  color: red;
}

.check-list{
  max-height: 380px;
overflow-x: auto;
scrollbar-width: thin;
}
.type-add-btn{
  padding: 2px 7px !important;
  border-radius: 6px !important;
}
.pcls{
  margin-bottom: 0px;
}
.load-margin{
  margin-left: 15px;
  margin-top: 15px;
}
.maxWidth990{
  max-width: 990px !important;
}
</style>

